// apollo/createLoadingLink.js
import { ApolloLink }   from '@apollo/client/core'
import { Observable }   from '@apollo/client/utilities'
import { ref }          from 'vue'

export function useApolloLoadingLink(){

    const isLoading = ref(false)
    let activeRequests          = 0

    const updateLoadingState = ({ hideCallback }) => {
        activeRequests--

        if (activeRequests <= 0) {
            activeRequests      = 0 // evita valori negativi
            isLoading.value     = false

            hideCallback()
        }
    }

    const getLoadingLink        = ({ showCallback, hideCallback }) => {

        return new ApolloLink((operation, forward) => {

            const context = operation.getContext()

            if (context?.suppressLoading) {
                return forward(operation)
            }

            activeRequests++
            isLoading.value = true

            showCallback()

            let settled = false

            const finalize = () => {
                if (!settled) {
                    settled = true

                    updateLoadingState({
                        hideCallback: hideCallback
                    })

                }
            }

            return new Observable(observer => {
                const subscription = forward(operation).subscribe({
                    next: result => observer.next(result),
                    error: err => {
                        observer.error(err)
                        finalize()
                    },
                    complete: () => {
                        observer.complete()
                        finalize()
                    }
                })

                return () => {
                    subscription.unsubscribe()
                    finalize()
                }
            })
        })

    }

    return {
        getLoadingLink,
        isLoading
    }
}